import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { AyrDescriptionComponent } from '../../shared/components/ayr-description/ayr-description.component';
// import { AyrNewsComponent } from '../../shared/components/ayr-news/ayr-news.component';
// import { AyrReviewsComponent } from '../../shared/components/ayr-reviews/ayr-reviews.component';
import { ImageModel } from '../../model/image.model';
import { HowItWorksComponent } from '../../shared/components/how-it-works/how-it-works.component';
import { DarkModeService } from '../../shared/services/darkmode.service';
import { Title } from '@angular/platform-browser';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home',
  imports: [
    RouterModule,
    CarouselModule,
    HeroSectionComponent,
    AyrDescriptionComponent,
    HowItWorksComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  isDarkMode!: boolean;
  list: ImageModel[] = [];
  customOptions: OwlOptions = {
    // When carousel not needed, set false to mouseDrag, pullDrag, dots and nav
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 0,
    stagePadding: 0,
    navSpeed: 700,
    items: 1,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  constructor(
    private darkModeService: DarkModeService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Are you ready? | Home');
    // Fetch news items from HomeService
    this.list = this.imagesBuilder();

    this.darkModeService.isDarkMode.subscribe((enabled) => {
      this.isDarkMode = enabled;
    });
  }

  imagesBuilder() {
    let home: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_02_Overview.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_02_Overview.webp',
      alt: '',
      title: 'home',
    };

    let account: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_05_AccountExpanded.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_05_AccountExpanded.webp',
      alt: '',
      title: 'account',
    };

    let climate: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_07_ProfileResources.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_07_ProfileResources.webp',
      alt: '',
      title: 'profile',
    };

    let resources: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_06_Resources.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_06_Resources.webp',
      alt: '',
      title: 'resources',
    };

    this.list.push(home);
    this.list.push(account);
    this.list.push(climate);
    this.list.push(resources);

    return this.list;
  }
}
